const { m } = require('minthril');

function AboutPage() {
  return {
    view: () => m('article.about',
      m('header.about__masthead',
        m('p.products__eyebrow', 'The story'),
        m('h1', 'Built for the space between impossible and perfect.'),
        m('p.about__standfirst', 'Mid Engine Co is an independent performance parts company from the Gold Coast, Queensland, building the things the catalogue forgot.')
      ),
      m('div.about__body',
        m('div.about__lead',
          m('p', 'Every day, parts leave our workshop on the Gold Coast for garages, workshops and owners around the world.'),
          m('p', 'The range begins with a simple conviction: the right solution is worth making properly.')
        ),
        m('div.about__copy',
          m('p', 'Founded by Glen Hordern, Mid Engine Co is shaped by a trade background in patternmaking and reverse engineering, and more than 35 years spent building and modifying performance cars.'),
          m('p', 'Glen grew up with a mechanical engineer for a father. Early lessons in engineering principles, practical problem-solving and doing things properly became a way of working—and still define the standard behind every product.'),
          m('blockquote', 'Hands-on experience is where the brief begins. Engineering is how we finish it.'),
          m('p', 'From our Gold Coast base, we work with trusted local specialists in 3D scanning and CAD design, and bring in qualified mechanical engineers when the job demands it. The result is a practical combination of lived experience, modern technology and professional rigour.'),
          m('p', 'We develop solutions for parts that are unavailable, unreliable or prohibitively expensive. Not replicas for the sake of it—considered alternatives that belong on the car and hold up in the real world.')
        )
      ),
      m('section.about__future',
        m('p.products__eyebrow', 'The road ahead'),
        m('h2', 'Gallardo is the beginning.'),
        m('p', 'The current range is focused on the Lamborghini Gallardo, with new work underway for the Ferrari 360 and F430. The long-term aim is straightforward: keep expanding the range and give owners and workshops worldwide access to reliable, well-engineered alternatives for the mid-engine cars they care about.')
      ),
      m('section.about__contact',
        m('p.products__eyebrow', 'Have a question?'),
        m('p', 'Tell us what you are working on and we will help you find the right direction.'),
        m('a', { href: '/contact' }, 'Start a conversation →')
      )
    )
  };
}

module.exports = { AboutPage };
